<template>
  <div>
    <v-row align="center">
      <v-col class="d-flex" cols="12" sm="4" md="6">
        <app-history
          @clicked="
            showDialog = true;
            currentBranch = initBranch;
          "
          title="افزودن شعبه"
        />
      </v-col>
      <v-col class="d-flex" style="padding: 0 30px" cols="12" sm="8" md="6">
        <v-text-field v-model="searchInput"></v-text-field>
      </v-col>
    </v-row>

    <div>
      <v-data-table
        :items="filteredBranch"
        :headers="branchHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.active`]="{ item }">
          {{ item.active ? "بله" : "خیر" }}
        </template>
        <template v-slot:[`item.reserveBeforeWeekend`]="{ item }">
          {{ item.reserveBeforeWeekend ? "بله" : "خیر" }}
        </template>
        <template v-slot:[`item.automaticJarimeh`]="{ item }">
          {{ item.automaticJarimeh ? "بله" : "خیر" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="dialogButton" rounded @click="editItem(item)"
            >ویرایش</v-btn
          >
          <v-btn class="dialogButton" rounded @click="setCurrentBranch(item)"
            >جزییات شعبه</v-btn
          >
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> شناسه مدرسه </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentBranch.schoolId"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> نام </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field v-model="currentBranch.name"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> شناسه ترمینال </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentBranch.terminalId"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="10"> فعال </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentBranch.active"></v-switch>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="10"> رزرو هفتگی </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentBranch.reserveBeforeWeekend"></v-switch>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="10"> جریمه خودکار </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentBranch.automaticJarimeh"></v-switch>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetAllBranches, SaveBranch } from "@/api/branch";
import { setCurrentBranch } from "@/utils/auth";
import { toArabicCharacter } from "@/utils/constants";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      branches: [],
      currentBranch: {
        schoolId: "",
        name: "",
        terminalId: "",
        active: true,
        reserveBeforeWeekend: false,
        id: "0",
        automaticJarimeh: false,
      },
      initBranch: {
        schoolId: "",
        name: "",
        terminalId: "",
        active: true,
        reserveBeforeWeekend: false,
        id: "0",
        automaticJarimeh: false,
      },
      searchInput: "",
      branchHeaders: [
        {
          text: "شناسه",
          value: "id",
          width: "10%",
        },
        {
          text: "نام",
          value: "name",
          width: "20%",
        },

        {
          text: "شناسه مدرسه",
          value: "schoolId",
          width: "10%",
        },
        {
          text: "فعال",
          value: "active",
          width: "5%",
        },
        {
          text: "رزرو هفتگی",
          value: "reserveBeforeWeekend",
          width: "10%",
        },
        {
          text: "جریمه خودکار",
          value: "automaticJarimeh",
          width: "10%",
        },
        {
          text: "شناسه ترمینال",
          value: "terminalId",
          width: "10%",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.GetAllBranches();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    filteredBranch() {
      return this.branches.filter((single) => {
        return single.name.includes(toArabicCharacter(this.searchInput));
      });
    },
  },
  methods: {
    GetAllBranches() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetAllBranches()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.branches = response.data.items;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    editItem(item) {
      this.currentBranch = Object.assign({}, item);
      this.showDialog = true;
    },
    setCurrentBranch(item) {
      setCurrentBranch(JSON.stringify(item));
      if (!this.isMobile) window.location = "/branch/menus";
      else window.location = "/branch/options";
    },
    applyRequest() {
      var text = "";

      if (this.schoolid == "") {
        text = "شناسه مدرسه نباید خالی باشد.";
      } else if (this.name == "") {
        text = "نام نباید خالی باشد.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        SaveBranch(
          this.currentBranch.id,
          this.currentBranch.schoolId,
          this.currentBranch.name,
          this.currentBranch.active,
          this.currentBranch.terminalId,
          this.currentBranch.reserveBeforeWeekend,
          this.currentBranch.automaticJarimeh
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showDialog = false;
            this.GetAllBranches();
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        removeTahsilRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.Success) {
              this.geTahsilHistory();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
